import { ReturnTypeEnum } from "@redotech/redo-model/return";
import { folderSchemas } from "@redotech/redo-model/views/folders";
import { viewWithIdSchemas } from "@redotech/redo-model/views/views";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";
import { null as zNull } from "zod/v4";
export const saveReturnViewsAndFolders = {
  name: "saveReturnViewsAndFolders" as const,
  input: z.object({
    folders: z.array(folderSchemas.returns),
    views: z.array(viewWithIdSchemas.returns),
    type: createEnum(ReturnTypeEnum),
  }),
  output: zNull(),
};
